import { AnimationBaseController, IAnimationControllerConfiguration, Inject, Key } from "@denishussar/html5-game-engine";
import { IFieldSize } from "../../Constants/FieldSizesConstants";
import { GameEventsConstants } from "../../Constants/GameEventsConstants";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";
import { PlayerTypeConstants } from "../../Constants/PlayerTypeConstants";
import { ConverUnitHelpers } from "../../Helpers/Helpers";
import { GameLogic } from "../../Logic/GameLogic";
import { PlayerModel } from "../../Models/PlayerModel";
import { AnimationContents } from "../AnimationContents";
import { PlayerDragonBonesController } from "./PlayerDragonBonesController";

export interface IPlayerControllerOptions{

}
export class PlayerController extends AnimationBaseController{
    $model: PlayerModel;
    protected _dbPlayer: PlayerDragonBonesController;
    private _isPressed = false;
    private _isEnabled = true;
    private _clickX = 0;
    private _preveMovePositionX = 0;
    private _playerMoveDirection = 1;
    protected fieldSize: IFieldSize;

    public constructor(
        @Inject protected _options: IPlayerControllerOptions,
        @Inject protected _gameLogic: GameLogic
    ) {
        super("PlayerController");
        console.log('PlayerController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAMES_SCREEN_JSON,
            libraryName: "character",
            modelWatch: {
                x: (x) => {
                    this.x = x;
                },
                active: (currentTurn: PlayerTurnConstant) => {
                    this.visible = this.$model.active;
                },
                type: (type: PlayerTypeConstants) => {
                    this._createDbPlayer();
                },
                hits: (hits: number, prevHits: number) => {
                    if(hits > prevHits) {
                        this._dbPlayer.throw();
                    }
                },
                behindCamera: (behindCamera: boolean) => {
                    this.visible = !behindCamera;
                    if (behindCamera) {
                        this._dbPlayer.idle();
                    }
                },
                isRightHand: (isRightHand: boolean) => {
                    this.scaleX = this.$model.isRightHand ? 1 : -1;
                }
            },
            modelEvents: {
                [GameEventsConstants.directionChangeStart]: () => {
                    this._dbPlayer.swing();
                },
                [GameEventsConstants.preventStart]: () => {
                    this._dbPlayer.idle();
                },
            },
            onPointerDown: (e) => {
                if (!this._isEnabled) {
                    return;
                }
                this._clickX = e.screenPosition.x;
                this._preveMovePositionX = e.localPosition.x;
                this._isPressed = true;
                this._calc(e);
                this._dbPlayer.moveRight();
            },
            onPointerUp: () => {
                this._pointerUpHandler();
            },
            onPointerUpOutside: () => {
                this._pointerUpHandler();
            },
            onPointerMove: (e) => {
                if (this._isPressed && this._isEnabled) {
                    const direction = e.localPosition.x < this._preveMovePositionX ? 1 : -1;
                        if (direction !== this._playerMoveDirection) {
                            if (this._playerMoveDirection > 0) {
                                this._dbPlayer.moveRight();
                            } else {
                                this._dbPlayer.moveLeft();
                            }
                        }
                        this._playerMoveDirection = direction;
                    this._preveMovePositionX = e.localPosition.x;
                    this._calc(e);
                }
            }
        };
    }
    protected onInitialize(): void {
        console.log('PlayerController.onInitialize', this);
        this.x = -200;
        this.y = 290;

        this.visible = this.$model.active;
        this._createDbPlayer();
        this.scaleX = this.$model.isRightHand ? 1 : -1;

    }

    public disable() {
        this._isPressed = false;
        this._isEnabled = false;
    }

    public enable() {
        this._isEnabled = true;
    }

    public updateByModel() {
        this.x = this.$model.x;
    }

    private _calc(e) {
        let x = e.localPosition.x - this._clickX;
        const right = ConverUnitHelpers.mmTo2D(0.5 * this.fieldSize.width);
        const left = ConverUnitHelpers.mmTo2D(-0.5 * this.fieldSize.width);
        if (x >= right ) {
            x = right;
        } else if (x <= left) {
            x = left;
        }

        this._gameLogic.setPlayerX(x);
    }


    private _pointerUpHandler() {
        if (!this._isEnabled || !this._isPressed) {
            return;
        }
        this._isPressed = false;
        this._dbPlayer.idle();
    }

    private _createDbPlayer() {
        if (this._dbPlayer) {
            this.removeChildController(this._dbPlayer);
        }

        const characterMap = {
            [PlayerTypeConstants.Kid]: 'girl_back',
            [PlayerTypeConstants.Woman]: 'woman_back',
            [PlayerTypeConstants.Man]: 'man_back',
            [PlayerTypeConstants.Oldman]: 'old_back',
        }

        const player = this.addChildController({
            view: PlayerDragonBonesController,
            options: {
                name: characterMap[this.$model.type]
            }
        }, 'animation') as PlayerDragonBonesController;

        this._dbPlayer = player;
    }

    public setFieldSize(size: IFieldSize) {
        this.fieldSize = size;
    }

}